import type { Attachment } from "@/types/attachment";
import type { FileAttachment } from "./types";

export const formatFileSize = (size: number, fixed = 0) => {
  if (!size) return "-";
  const bytes = size;
  const units = ["B", "KB", "MB", "GB", "TB"];

  if (bytes === 0) {
    return "0 B";
  }

  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const fileSize = (bytes / Math.pow(1024, i)).toFixed(fixed);

  return `${fileSize} ${units[i]}`;
};

export function getFileAttachmentId(value: FileAttachment) {
  if (isAttachment(value)) {
    return value.id;
  }
  return value.id || value.file.name + value.file.lastModified;
}

export function isAttachment(value: FileAttachment): value is Attachment {
  return !!(value as Attachment).mime_type;
}
